import BCH from "../assets/images/currencies/BCH.svg";
import BNB from "../assets/images/currencies/BNB.svg";
import BTC from "../assets/images/currencies/BTC.svg";
import DAI from "../assets/images/currencies/DAI.svg";
import DASH from "../assets/images/currencies/DASH.svg";
import DOGE from "../assets/images/currencies/DOGE.svg";
import DOT from "../assets/images/currencies/DOT.svg";
import ETC from "../assets/images/currencies/ETC.svg";
import ETH from "../assets/images/currencies/ETH.svg";
import EUR from "../assets/images/currencies/EUR.svg";
import LTC from "../assets/images/currencies/LTC.svg";
import NEAR from "../assets/images/currencies/NEAR.svg";
import PLN from "../assets/images/currencies/PLN.svg";
import POL from "../assets/images/currencies/POL.svg";
import SOL from "../assets/images/currencies/SOL.svg";
import TON from "../assets/images/currencies/TON.svg";
import TRX from "../assets/images/currencies/TRX.svg";
import UAH from "../assets/images/currencies/UAH.svg";
import USDC from "../assets/images/currencies/USDC.svg";
import USDT from "../assets/images/currencies/USDT.svg";
import XMR from "../assets/images/currencies/XMR.svg";
import XRP from "../assets/images/currencies/XRP.svg";
import ZEC from "../assets/images/currencies/ZEC.svg";
import OP from "../assets/images/currencies/OP.svg";

interface Currency {
  [key: string]: string;
}

export const availableCurrencies: Currency = {
  BCH,
  BNB,
  BTC,
  DAI,
  DASH,
  DOGE,
  DOT,
  ETC,
  ETH,
  EUR,
  LTC,
  NEAR,
  PLN,
  POL,
  SOL,
  TON,
  TRX,
  UAH,
  USDC,
  USDT,
  XMR,
  XRP,
  ZEC,
  OP,
};

